import React from "react";

/** Centered mobile-app frame (max 480px wide, full-bleed background). */
export const MobileFrame = ({ children }) => {
  return (
    <div className="min-h-screen w-full bg-[#EFEDE5] flex justify-center">
      <div
        data-testid="mobile-frame"
        className="relative w-full max-w-[480px] min-h-screen bg-[#FDFBF7] shadow-[0_0_60px_rgba(45,49,66,0.08)]"
      >
        {children}
      </div>
    </div>
  );
};
